export type UserRole =
  | "Super Admin"
  | "Admin"
  | "Content Creator"
  | "Co-ordinator"
  | "Teacher"
  | "Student"
  | "Private";

export type BillingStatus = "Paid" | "Failed";

export type RenewalStatus = "Renewing" | "Cancelling";

export type AuthenticationStatus = "Unauthenticated" | "Authenticated";

export const DEV_LOGIN_DENIED_MESSAGE = "You can't log in to this site";
